export default __webpack_public_path__ + "img/bg-tab1and2_nav6-c663ceea.png";